import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { ReducerStateType } from './types';

const initialState = {
  offset: 0,
  limit: 25,
  search: '',
  order: 'desc',
  sortBy: 'joinedOn',
  clearPage: true
} as ReducerStateType;

export const userListingSlice = createSlice({
  name: 'userListing',
  initialState,
  reducers: {
    resetValues: state => ({
      ...state,
      offset: 0,
      limit: 25,
      search: '',
      order: 'desc',
      sortBy: 'joinedOn'
    }),
    updateValues: (state, { payload }) => ({
      ...state,
      ...payload
    }),
    updateUserListingClearPage: (
      state,
      { payload }: PayloadAction<boolean>
    ) => ({
      ...state,
      clearPage: payload
    })
  }
});

export const { resetValues, updateValues, updateUserListingClearPage } =
  userListingSlice.actions;

export default userListingSlice.reducer;
